import dayjs from 'dayjs';

/** Longest value a filter button shows; the chip bar under it shows the full text. */
export const FILTER_VALUE_MAX_CHARS = 24;

/** Cuts a long value with "…" so the filter bar stays on one line. */
export const truncateFilterValue = (text, max = FILTER_VALUE_MAX_CHARS) => {
    const value = String(text ?? '');
    return value.length > max ? `${value.slice(0, max - 1)}…` : value;
};

/** Lets the operator see what a filter is set to without opening it: "Client" → "Client: ACME". */
export const formatFilterButtonLabel = (label, valueText) =>
    valueText ? `${label}: ${truncateFilterValue(valueText)}` : label;

/** The search period as the operator reads it: "10/01/25 – 10/01/26"; a missing end shows as "…". */
export const formatDateWindowText = (start, end) => {
    const fmt = (ymd) => (ymd ? dayjs(ymd).format('MM/DD/YY') : '…');
    if (!start && !end) return '';
    return `${fmt(start)} – ${fmt(end)}`;
};

/** Several picked values in one short label: "ACME +2" = ACME and two more. */
export const formatMultiValueText = (values, textOf = optionText) => {
    const list = Array.isArray(values) ? values.filter(Boolean) : [];
    if (list.length === 0) return '';
    const first = textOf(list[0]);
    return list.length === 1 ? first : `${first} +${list.length - 1}`;
};

/** How a picked option reads: "code | name" for locations, otherwise the name. */
export const optionText = (option) => {
    if (!option) return '';
    if (typeof option === 'string') return option;
    return option.code && option.name ? `${option.code} | ${option.name}` : (option.name ?? '');
};
